export interface ICallHistoryProps {
  list: ICallHistory[];
  noOfRecords: number;
  showTooltip?: boolean;
}

export interface ICallHistory {
  callerStatus: string;
  receiverStatus: string;
  interactionTimestamp: string;
  durationInSeconds: string;
}

export const CALL_STATUSES = {
  ANSWER: 'ANSWER',
  NOANSWER: 'NOANSWER',
  FAILED: 'FAILED'
};

export interface ICallStatusProps {
  receiverStatus: string;
  interactionTimestamp: string;
  tooltip: string;
}

export interface ICallStatusListProps {
  list: ICallHistory[];
  showTooltip: boolean | undefined;
}
